module.exports = __webpack_public_path__ + "static/img/12.fffc6a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/12.png
// module id = XL89
// module chunks = 0